import { Doughnut, mixins } from 'vue-chartjs';
const { reactiveProp } = mixins;

export default {
    mixins: [reactiveProp, Doughnut],
    mounted() {
        this.renderChart(this.chartData, this.options)
    }
}